(function () {
  // Mulberry injects its warranty widget as a cross-origin <iframe> with NO
  // title/aria-label, so it reaches the a11y tree as an unnamed frame. Screen
  // readers announce it only as "frame", and Lighthouse/axe fail it as
  // `frame-title` (weight 7 — the joint-largest remaining term in this page's
  // mobile accessibility score).
  //
  // We cannot set the attribute inside Mulberry's document (cross-origin), but
  // `title` is a PARENT-side attribute on the <iframe> element itself, so the
  // theme can supply the accessible name without touching their bundle.
  var TITLE = 'Product protection plan options';

  // Two containers, because Mulberry renders in two phases: the inline offer
  // under the product form (.mulberry-inline-container) and a modal that is
  // only populated when the shopper opens it (.mulberry-modal). The src match
  // is the durable backstop if either class is ever renamed.
  //
  // 🚨 NEVER widen this to a substring class match like '[class*="mulberry"]
  // iframe'. Mulberry stamps `mulberry-loaded` on <body>, so that selector
  // matches EVERY iframe on the page — measured 10 of 10 on this PDP: the five
  // Shopify web-pixel sandboxes, the admin preview bar, the Trade Desk pixel
  // and the HubSpot chat widget. Naming those "Product protection plan options"
  // is an accessibility REGRESSION, not a fix: a screen reader would announce
  // the chat widget as a warranty offer. The selectors below match exactly the
  // one real Mulberry frame (verified 1 of 1 on production).
  var SELECTOR = [
    '.mulberry-inline-container iframe',
    '.mulberry-modal iframe',
    'iframe[src*="getmulberry.com"]'
  ].join(', ');

  function untitledMulberryFrames() {
    var found = [];
    var els = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) {
      // Never overwrite a name Mulberry (or a future fix) already supplies —
      // theirs would be more specific than our generic string.
      if (!els[i].getAttribute('title') && !els[i].getAttribute('aria-label')) {
        found.push(els[i]);
      }
    }
    return found;
  }

  function fixMulberryFrameTitles() {
    var els = untitledMulberryFrames();
    for (var i = 0; i < els.length; i++) {
      els[i].setAttribute('title', TITLE);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixMulberryFrameTitles);
  } else {
    fixMulberryFrameTitles();
  }

  // The container itself is injected by Mulberry, so it does not exist at parse
  // time and cannot be observed directly the way judgeme-aria-fix observes
  // #judgeme_product_reviews. Observe the document instead, but keep the work
  // per-batch trivial (one narrow querySelectorAll) and disconnect as soon as a
  // frame exists and nothing is untitled. The 10s timer is the backstop for
  // pages where Mulberry never renders (it is offer-gated, so that is normal).
  var safetyTimer;
  var obs = new MutationObserver(function () {
    fixMulberryFrameTitles();
    if (document.querySelector(SELECTOR) && !untitledMulberryFrames().length) {
      obs.disconnect();
      clearTimeout(safetyTimer);
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  safetyTimer = setTimeout(function () {
    obs.disconnect();
  }, 10000);

  // 2s backstop: covers the case where the widget injected before this script
  // ran and the observer therefore saw no mutation batch for it.
  setTimeout(fixMulberryFrameTitles, 2000);
})();
